export default [ 
    {
        path: '/terminal-device/:id',
        name: 'terminal-device',
        component: () =>
            import('@/views/TerminalRegister/TerminalRegister.vue'),
        meta: {
            permitAll: true,
        },
    },
    {
        path: '/tools-cart',
        name: 'tools_cart',
        component: () => import('@/views/Terminals/ToolsCart/ToolsCart.vue'),
        meta: {
            permitAll: true,
            availableAsTerminalDefaultView: true,
            bc: [
                { text: 'common.toolsPicker', to: { name: 'tools_cart' } },
            ],
        },
    },
    {
        path: '/storage-cart',
        name: 'storageCart',
        component: () => import('@/views/Terminals/StorageCart/StorageCartIndex.vue'),
        meta: {
            availableAsTerminalDefaultView: true,
            currentAccessName: 'terminal.parts-exchange',
        },
    },
    {
        path: '/terminal-issues',
        name: 'terminal_issues',
        component: () => import ('@/views/Terminals/IssuesTerminal/IssuesTerminalIndex.vue'),
        meta: {
            permitAll: true //TODO
        }
    }
]